import React from 'react';
import {
  getHealthColorClass,
  LOW_THRESHOLD,
  MEDIUM_THRESHOLD,
  VERY_LOW_THRESHOLD,
} from './healthThreshold';

interface HealthIconProps {
  marginUsage: number;
}

export const HealthIcon: React.FC<HealthIconProps> = ({ marginUsage }) => {
  // Calculate how many bars should be filled based on health value
  const getFilledBars = (): number => {
    if (marginUsage < VERY_LOW_THRESHOLD) return 1;
    if (marginUsage < LOW_THRESHOLD) return 2;
    if (marginUsage < MEDIUM_THRESHOLD) return 3;
    return 4;
  };

  const filledBars = getFilledBars();
  const colorClass = getHealthColorClass(marginUsage);

  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={colorClass}
    >
      <rect y="9" width="3" height="3" rx="1" fill={filledBars >= 1 ? 'currentColor' : '#52525B'} />
      <rect
        x="5"
        y="6"
        width="3"
        height="6"
        rx="1"
        fill={filledBars >= 2 ? 'currentColor' : '#52525B'}
      />
      <rect
        x="10"
        y="3"
        width="3"
        height="9"
        rx="1"
        fill={filledBars >= 3 ? 'currentColor' : '#52525B'}
      />
      <rect
        x="15"
        width="3"
        height="12"
        rx="1"
        fill={filledBars >= 4 ? 'currentColor' : '#52525B'}
      />
    </svg>
  );
};
